import React from 'react';

import logo from '../images/logo.svg';
import { Link } from 'react-router-dom';
import LoginForm from '../components/LoginForm';

import { useUser } from '../contexts/user';
/*
const Terms = () => {
    return (
        <div className="footer-bottom has-text-centered has-text-grey has-text-weight-light is-size-7">
            By signing in to <Link to="/">greetings.wallknown.com</Link>, you agree to our <a href="/">terms of service.</a>
        </div>
    )
}*/

const LoginPage = () => {
    const { socialLogin } = useUser();

    return (
        <section className="hero">
            <div>
                <div className="container has-text-centered">
                    <div className="column is-4 is-offset-4">

                        <figure className="py-4">
                            <Link to='/'>
                                <img src={logo} alt="logo" />
                            </Link>
                        </figure>

                        <div>
                            <blockquote className="brooks">
                                Collect Moments not Things
                            </blockquote>
                        </div>

                        <div className="box mt-5 px-5 py-5">
                            <LoginForm socialLogin={socialLogin} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default LoginPage;